<template>
  <div>
    <div v-if="showLabel">
      <span class="caption grey--text left">{{
        $t('internship.Internship')
      }}</span
      ><br />
    </div>
    <v-select
      label="Estágio"
      :value="value"
      :items="availableInternships"
      clearable
      @input="$emit('input', $event)"
      single-line
      :disabled="disabled"
      :hint="showHint(availableInternships)"
      persistent-hint
      :hide-details="hideDetails"
      solo
      class="thin-border"
    />
    <p v-if="emptyLine && showSpecialty" />
    <div v-if="showSpecialty">
      <span class="caption grey--text left">{{ $t('common.Specialty') }}</span
      ><br />
      <v-select
        :value="specialty"
        item-value="id"
        item-text="name"
        :items="specialtyOptions"
        clearable
        @change="setSpecialty"
        solo
        class="thin-border"
      />
    </div>
  </div>
</template>

<script>
import { Internship, Option } from '../../../models/Specialty'
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    specialty: {
      type: String,
      default: ''
    },
    showSpecialty: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      emptyLine: false
    }
  },

  computed: {
    ...mapGetters(['internships', 'selectedSpecialty']),
    specialtyOptions() {
      return Option.query()
        .where('component', 'specialty')
        .get()
        .sort((a, b) => a.text.localeCompare(b.text))
        .map(({ value, text }) => ({ id: value, name: text }))
    },
    availableInternships() {
      const specialtyInternships = Internship.query().get()

      return this.internships.map(i => {
        const found = specialtyInternships.find(si => {
          return i.internship === si.id
        })
        if (found) {
          return { text: found.label, value: i.internship }
        } else {
          return { text: i.internship, value: i.internship }
        }
      })
    }
  },
  methods: {
    ...mapActions(['getInternships', 'showErrorSnackbar']),
    showHint(items) {
      if (this.hint) {
        this.emptyLine = true
        if (items.length === 0) {
          return 'Sem Estágios. Por favor crie um Estágio na secção Estágios.'
        }

        if (this.value) {
          return ''
        }
        return 'Define o estágio relacionado com o registo.'
      }
    },
    setSpecialty(specialty) {
      this.$emit('update:specialty', specialty)
    }
  }
}
</script>
